import apiClient from './api';

// ====== Public API ======

export const getVoicePackageCountries = () =>
  apiClient.get('/voice-packages/countries');

// ====== Admin API ======

export const getAdminVoicePackages = (params = {}) => {
  const searchParams = new URLSearchParams();
  if (params.country) searchParams.append('country', params.country);
  if (params.search) searchParams.append('search', params.search);
  if (params.page) searchParams.append('page', params.page);
  if (params.limit) searchParams.append('limit', params.limit);
  return apiClient.get(`/admin/voice-packages?${searchParams.toString()}`);
};

export const createVoicePackage = (pkg) =>
  apiClient.post('/admin/voice-packages', pkg);

export const updateVoicePackage = (id, pkg) =>
  apiClient.put(`/admin/voice-packages/${id}`, pkg);

export const deleteVoicePackage = (id) =>
  apiClient.delete(`/admin/voice-packages/${id}`);

export const toggleVoicePackageActive = (id) =>
  apiClient.patch(`/admin/voice-packages/${id}/active`);
